import { Badge, BadgeProps, Icon, useDisclosure } from '@chakra-ui/react';
import { FiEye } from 'react-icons/fi';
import RegistrationAnalysisResultModal from './RegistrationAnalysisResultModal';

interface RegistrationStatusBadgeProps extends Omit<BadgeProps, 'children' | 'onClick'> {
  registrationId: string;
  status: string;
  allowFilterVacancyTree?: boolean;
}

const RegistrationStatusBadge: React.FC<RegistrationStatusBadgeProps> = ({
  registrationId,
  status,
  allowFilterVacancyTree,
  ...badgeProps
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!allowFilterVacancyTree) return <Badge {...badgeProps}>{status}</Badge>;

  return (
    <>
      <Badge
        {...badgeProps}
        as="button"
        type="button"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        gap={1.5}
        cursor="pointer"
        onClick={onOpen}
        title="Ver detalhes da análise da inscrição"
        aria-label={`Ver detalhes da análise da inscrição: ${status}`}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        _hover={{ filter: 'brightness(0.95)' }}
        _focusVisible={{ boxShadow: 'outline' }}
      >
        <Icon as={FiEye} boxSize="14px" flexShrink={0} aria-hidden="true" />
        {status}
      </Badge>
      {isOpen && <RegistrationAnalysisResultModal isOpen={isOpen} onClose={onClose} registrationId={registrationId} />}
    </>
  );
};

export default RegistrationStatusBadge;
